var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.571 1.714H14a2.011 2.011 0 0 1 2 2V14a2.012 2.012 0 0 1-2 2H2a2.012 2.012 0 0 1-2-2V3.714a2.011 2.011 0 0 1 2-2h1.429a.286.286 0 0 0 .285-.285V.857a.857.857 0 1 1 1.715 0v.572a.286.286 0 0 0 .285.285h4.572a.285.285 0 0 0 .285-.285V.857a.857.857 0 1 1 1.715 0v.572a.286.286 0 0 0 .285.285ZM1.798 3.512a.286.286 0 0 0-.084.202V6A.286.286 0 0 0 2 6.286h12A.286.286 0 0 0 14.286 6V3.714A.286.286 0 0 0 14 3.43h-1.429a.286.286 0 0 0-.285.285v.572a.857.857 0 0 1-1.715 0v-.572a.286.286 0 0 0-.285-.285H5.714a.286.286 0 0 0-.285.285v.572a.857.857 0 1 1-1.715 0v-.572a.286.286 0 0 0-.285-.285H2a.286.286 0 0 0-.202.083ZM2.222 8c-.245 0-.489.199-.489.444v5.334c0 .245.244.444.49.444h11.555c.245 0 .489-.199.489-.444V8.444c0-.245-.244-.444-.49-.444H2.223Z"
  })));
};

export default SvgCalendar;